<template>
  <div>
    <div class="pt-4 flex lg:hidden">
      <Skeleton class="mr-4" width="5rem" height="5rem" rounded radius="12px" />
      <div class="flex flex-col justify-between py-2">
        <div>
          <Skeleton class="mb-2" width="10rem" height="1rem" rounded />
          <Skeleton width="3rem" height=".7rem" rounded />
        </div>
        <div class="flex">
          <Skeleton class="mr-2" width="1rem" height="1rem" type="circle" />
          <Skeleton class="mr-2" width="1rem" height="1rem" type="circle" />
          <Skeleton class="mr-2" width="1rem" height="1rem" type="circle" />
        </div>
      </div>
    </div>
    <div class="w-fill mt-6">
      <div
        class="hidden lg:flex flex-col rounded-xl overflow-hidden bg-gray-100"
      >
        <div class="h-32 w-full">
          <div class="pl-4 pt-4 flex">
            <Skeleton width="30%" height="5rem" radius="12px" rounded />
            <div>
              <Skeleton class="mt-6 ml-10" width="5rem" height="1rem" rounded />
              <Skeleton class="mt-2 ml-10" width="5rem" height="1rem" rounded />
            </div>
            <div class="flex items-center self-center">
              <Skeleton
                class="ml-20 mr-2"
                width="2.5rem"
                height="2.5rem"
                type="circle"
              />
            </div>
          </div>
          <div></div>
        </div>
        <!-- <div class="p-4 flex flex-col items-center ">
          <Skeleton class="mb-2" width="12rem" height="1rem" rounded />
          <Skeleton width="3rem" height=".7rem" rounded />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from "skeleton-loader-vue";

export default {
  name: "MenuItemSkeleton",
  components: {
    Skeleton,
  },
};
</script>

<style lang="scss"></style>
